import React from "react";
import { Col, Row, Typography, Form, InputNumber } from "antd";
import { UnspecifiedResidentSection_fields as inputDetails } from "./fields-object/fields-object";
const { Paragraph } = Typography;

const Index = () => {
  return (
    <>
      <Row gutter={10}>
        <Col span={12}>
          <Paragraph level={4}> Male </Paragraph>
        </Col>
        <Col span={12}>
          <Paragraph level={4}> Female </Paragraph>
        </Col>
      </Row>
      {inputDetails.map((input, index) => {
        return (
          <Row
            key={`row${index}`}
            gutter={10}
            justify="space-between"
            align="center"
          >
            {input.types.map((type, _index) => {
              return (
                <Col key={`inputField${_index}`} span={12}>
                  <Form.Item
                    name={[input.name, type]}
                    rules={[
                      {
                        required: true,
                        message: `Please input ${
                          input.label
                        } for ${type.toUpperCase()}`,
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        );
      })}
    </>
  );
};

export default Index;
